import { type SxProps, type Theme } from "@mui/material/styles";
import { twMerge } from "tailwind-merge";

import { Tooltip } from "ui/tooltip";

import Icons from "assets";

interface ContentTypeMismatchIconProps {
  customClass?: string;
}

const CONTENT_TYPE_MISMATCH_MESSAGE = "Content type doesn't match campaign objective";

const TOOLTIP_WRAPPER_SX: SxProps<Theme> = { display: "inline-flex", lineHeight: 1 };

const TOOLTIP_SX: SxProps<Theme> = { textAlign: "center" };

const ContentTypeMismatchIcon = ({ customClass }: ContentTypeMismatchIconProps) => {
  return (
    <Tooltip
      label={CONTENT_TYPE_MISMATCH_MESSAGE}
      placement="bottom"
      wrapperSx={TOOLTIP_WRAPPER_SX}
      width={176}
      sx={TOOLTIP_SX}>
      <Icons.WarningIndicator customClass={twMerge("text-warning-700", customClass)} />
    </Tooltip>
  );
};

export default ContentTypeMismatchIcon;
